module.exports = __webpack_public_path__ + "img/iot.464e65ac.png";